import { render, staticRenderFns } from "./500.vue?vue&type=template&id=25f0ff74&"
import script from "./500.vue?vue&type=script&lang=js&"
export * from "./500.vue?vue&type=script&lang=js&"
import style0 from "./500.vue?vue&type=style&index=0&id=25f0ff74&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports